import { render } from "./Colaboradores.vue?vue&type=template&id=fd3135aa&scoped=true"
import script from "./Colaboradores.vue?vue&type=script&lang=js"
export * from "./Colaboradores.vue?vue&type=script&lang=js"

import "./Colaboradores.vue?vue&type=style&index=0&id=fd3135aa&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd3135aa"]])

export default __exports__